import React, { ReactNode, useContext, useEffect } from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { PublicOfficeContext } from '../../context/PublicOfficeProvider';
import { OfficeT } from '../../types/office';
import { isTariffFree } from '../../util/tariff';

export interface PublicOfficeRouteProps extends RouteProps {
    office: OfficeT;
    children: ReactNode;
}

export const PublicOfficeRoute = ({ children, office, ...rest }: PublicOfficeRouteProps) => {
    const contextData = useContext(PublicOfficeContext);

    const handleSetOfficeBackground = contextData?.handleSetOfficeBackground;

    useEffect(() => {
        if (handleSetOfficeBackground) {
            const { backgroundImage, orgTariffMeta } = office;
            const { tariffName } = orgTariffMeta;

            const isFreeTariff = isTariffFree(tariffName);
            const bgImageSrc = backgroundImage ?? null;

            handleSetOfficeBackground(!isFreeTariff ? bgImageSrc : null);
        }

        return () => {
            if (handleSetOfficeBackground) {
                handleSetOfficeBackground(null);
            }
        };
    }, []);

    return <Route {...rest} render={() => <>{children}</>} />;
};
